import React from "react";

const Mandatory = ({ label, nonMandatory }) => {
  return (
    <>
      {!nonMandatory && (
        <span className="w-1 h-1 rounded bg-orange-500 inline-block mr-1"></span>
      )}
      <span className="capitalize">{label}</span>
    </>
  );
};

export default Mandatory;
